<template>
  <div class="row rodape">
    <div class="col-md-8 col-sm-12 redes-sociais">
      <span>Redes sociais</span>
      <a :href="getRedeSocial.facebook" target="_blank" class="ico-redes-sociais" v-if="getRedeSocial.facebook"><i class="fab fa-facebook-f"></i></a>
      <a :href="getRedeSocial.twitter" target="_blank" class="ico-redes-sociais" v-if="getRedeSocial.twitter"><i class="fab fa-twitter"></i></a>
      <a :href="getRedeSocial.youtube" target="_blank" class="ico-redes-sociais" v-if="getRedeSocial.youtube"><i class="fab fa-youtube"></i></a>
      <a :href="getRedeSocial.instagram" target="_blank" class="ico-redes-sociais" v-if="getRedeSocial.instagram"><i class="fab fa-instagram"></i></a>
      <a :href="getRedeSocial.whatsapp" target="_blank" class="ico-redes-sociais" v-if="getRedeSocial.whatsapp"><i class="fab fa-whatsapp"></i></a>
    </div>

    <div class="col-md-4 col-sm-12">
      <a  :href="getBuilderInfo.aparencia.builder.site_footer_name_link" :title="getBuilderInfo.aparencia.builder.version" target="_blank" class="link-max">{{ getBuilderInfo.aparencia.builder.site_footer_name }}</a>
    </div>
  </div>
</template>

<script>
  import services from '../service/api'

  export default {
    name: "FooterComp",
    data() {
      return {
        links: {},
        exibeLink:null
      }
    },
    mounted() {
      let self = this;
    },
    computed:{
      getCurrent() {
        return this.$store.getters['getCurrentInfo']
      },
      getBuilderInfo() {
        return this.$store.getters['getBuilderInfo']
      },
      getRedeSocial() {
        return this.$store.getters['getRedeSocial']
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/FooterComp.vue